import React, { Component } from 'react';
import config from '../../../config';
import ContentLeftTopTitle from './content-left-top-title/content-left-top-title';
import ContentLeftVisibleXs from './content-left-visiable-xs/content-left-visible-xs';
import ContentLeftDescription from './content-left-description/content-left-description';
import RelatedReport from './related-report/related-report';


class ContentLeft extends Component {
    constructor(props) {
        super(props);
        this.state = this.props;

    }

    render() {

            return (
                <div className="left-sec">
                    {/*Content Left Top title*/}
                    <ContentLeftTopTitle data_title={this.state} />

                    {/*Content Left Visible XS*/}
                    <ContentLeftVisibleXs data_visble={this.state} />

                    {/*Content Left Description*/}
                    <ContentLeftDescription data_desc={this.state} />

                    {/*Related Report: Sowmith asked to remove */}
                    {/*<RelatedReport />*/}

                </div>
            );


    }


}


export default ContentLeft;


// WEBPACK FOOTER //
// ./src/report-description/content/content-left/content-left.js